import { Link } from "react-router-dom";
import { ingredientsData, promisesData } from "../lib/data";
import { Reveal } from "../components/Reveal";
import { Icon } from "../components/Icon";
import { useLang } from "../context/LanguageContext";

export default function Formule() {
  const { t, lang } = useLang();
  const INGREDIENTS = ingredientsData(lang);
  const PROMISES = promisesData(lang);
  return (
    <div className="pt-32 pb-24">
      <div className="max-w-4xl mx-auto px-6 text-center mb-20">
        <Reveal>
          <p className="overline mb-4">{t("formule.overline")}</p>
          <h1 className="font-display text-5xl md:text-7xl mb-6 uppercase tracking-tight" style={{ fontWeight: 300 }}>{t("formule.title")}</h1>
          <p className="text-sm max-w-xl mx-auto" style={{ color: "var(--lo-muted)" }}>
            {t("formule.intro")}
          </p>
        </Reveal>
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 mb-20">
        <div className="flex flex-wrap justify-center gap-3">
          {PROMISES.map((p) => (
            <span key={p} className="overline px-6 py-3" style={{ border: "1px solid var(--lo-border-rose)", color: "var(--lo-rose-hi)" }}>{p}</span>
          ))}
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-4">
        {INGREDIENTS.map((ing, i) => (
          <Reveal key={ing.name} delay={i * 0.04}>
            <div className="card-lux p-8 flex gap-6 items-start h-full" data-testid={`formule-ingredient-${i}`}>
              <div className="w-12 h-12 flex items-center justify-center rounded-full border shrink-0" style={{ borderColor: "var(--lo-border-rose)" }}>
                <Icon name={ing.icon} size={20} stroke="var(--lo-rose)" strokeWidth={1} />
              </div>
              <div>
                <div className="flex items-center gap-3 mb-1">
                  <h3 className="font-display text-2xl" style={{ fontWeight: 400 }}>{ing.name}</h3>
                  {ing.key && <span className="overline" style={{ fontSize: "0.5rem", color: "var(--lo-rose)" }}>{t("formule.key_active")}</span>}
                </div>
                <p className="text-sm leading-relaxed" style={{ color: "var(--lo-muted)" }}>{ing.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <p className="text-center text-xs max-w-lg mx-auto mt-14 px-6" style={{ color: "var(--lo-muted)" }}>
        {t("formule.disclaimer")}
      </p>

      <div className="text-center mt-12">
        <Link to="/serum" className="btn-primary inline-flex items-center h-14 px-10" data-testid="formule-cta">{t("common.discover_serum")}</Link>
      </div>
    </div>
  );
}
